var delivery_message_default = (() => {
    if (customElements.get("delivery-message")) return;
    const MAX_COUNTDOWN_SECONDS = 720 * 60;
    customElements.define("delivery-message", class DeliveryMessage extends HTMLElement {
        constructor() {
            super();
            this.tick = this.tick.bind(this);
        }
        connectedCallback() {
            this.defaultEl = this.querySelector("[data-delivery-default]");
            this.countdownEl = this.querySelector("[data-delivery-countdown]");
            let cutoffRaw = null;
            try {
                cutoffRaw = JSON.parse(this.querySelector("[data-delivery-data]")?.textContent || "null");
            } catch {
                cutoffRaw = null;
            }
            if (!this.countdownEl || !cutoffRaw) return;
            const cutoffDate = new Date(cutoffRaw);
            if (isNaN(cutoffDate.getTime())) return;
            this.cutoffMinutes = cutoffDate.getUTCHours() * 60 + cutoffDate.getUTCMinutes();
            this.countdownEl.innerHTML = this.countdownEl.innerHTML.replace(/\{\{\s*time\s*\}\}/, '<span data-delivery-time role="timer" aria-live="off" class="font-medium"></span>');
            this.timeEl = this.countdownEl.querySelector("[data-delivery-time]");
            this.abbr = window.MBF?.strings?.timeUnitAbbreviation || {
                hour: "h",
                minute: "m",
                second: "s"
            };
            this.tick();
            this.interval = setInterval(this.tick, 1e3);
        }
        disconnectedCallback() {
            clearInterval(this.interval);
            this.interval = null;
        }
        tick() {
            const now = new Date;
            const nowMinutes = now.getUTCHours() * 60 + now.getUTCMinutes();
            const remaining = (this.cutoffMinutes - nowMinutes) * 60 - now.getUTCSeconds();
            if (remaining > 0 && remaining <= MAX_COUNTDOWN_SECONDS) {
                if (this.timeEl) this.timeEl.textContent = this.formatCountdown(remaining);
                this.show(this.countdownEl);
                this.hide(this.defaultEl);
            } else {
                this.show(this.defaultEl);
                this.hide(this.countdownEl);
            }
        }
        formatCountdown(totalSeconds) {
            const h = Math.floor(totalSeconds / 3600);
            const m = Math.floor(totalSeconds % 3600 / 60);
            const s = totalSeconds % 60;
            const units = [];
            if (h) units.push(`${h}${this.abbr.hour}`);
            if (m) units.push(`${m}${this.abbr.minute}`);
            if (s) units.push(`${s}${this.abbr.second}`);
            return units.length ? units.join(" ") : `0${this.abbr.second}`;
        }
        show(el) {
            if (!el) return;
            el.classList.remove("hidden");
            el.setAttribute("aria-hidden", "false");
        }
        hide(el) {
            if (!el) return;
            el.classList.add("hidden");
            el.setAttribute("aria-hidden", "true");
        }
    });
})();